/* eslint-disable no-return-assign */
/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { RadioButton, Tooltip } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
import CustomRadioButtonSettingsForm from './CustomRadioButton.settingsForm';
import getLocalParams from '../localizationCustoms';

const CustomRadioButton = class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.setValue = this.setValue.bind(this);
    this.getTypelist = this.getTypelist.bind(this);
  }

  setValue = (v) => {
    const { component, onChange } = this.props || undefined;
    const { label, useReviewLabel, reviewLabel } = component || undefined;
    this.setState({ value: { value: v, review: { label: useReviewLabel ? reviewLabel : label, typelist: this.getTypelist() } } }, () => {
      // eslint-disable-next-line react/destructuring-assignment
      onChange(this.state.value);
    });
  };

  getTypelist = () => {
    const options = {};
    const { component } = this.props || undefined;
    const { values } = component;
    values.forEach((option) => {
      options[option.value] = option.label;
    });
    return options;
  };

  render() {
    const { value } = this.state;
    const { component, disabled } = this.props || undefined;
    const { values, hideCustomLabel, label, tooltip } = component || undefined;
    return (
      values !== undefined && (
        <>
          {!hideCustomLabel && (
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <label className="label-question">
                <FormattedMessage id={label} defaultMessage={label} />
              </label>
              {tooltip !== '' && (
                <Tooltip id="radiobutton_tooltip" primary>
                  <FormattedMessage id={tooltip} defaultMessage={tooltip} />
                </Tooltip>
              )}
            </div>
          )}
          {values.map((radioIndex) => (
            <RadioButton
              secondary
              disabled={disabled}
              id={`id_radiobutton${Math.random() * 0xffffffffffff}`}
              key={`key_radiobutton${Math.random() * 0xffffffffffff}`}
              value={radioIndex.value}
              onChange={(v) => this.setValue(v)}
              checked={value ? value.value === radioIndex.value : false}
            >
              <FormattedMessage id={radioIndex.label} defaultMessage={radioIndex.label} />
            </RadioButton>
          ))}
        </>
      )
    );
  }
};

export default class RadioButtonComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Radio Button',
      icon: 'dot-circle-o',
      group: 'basic',
      weight: 80,
      documentation: '/userguide/#radio',
      schema: RadioButtonComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customradiobutton',
        inputType: 'radio',
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = CustomRadioButtonSettingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <CustomRadioButton
          ref={(refer) => {
            instance = refer;
          }}
          disabled={this._disabled}
          component={this.component} // These are the component settings if you want to use them to render the component.
          value={this.dataValue || this.dataForSetting} // The starting value of the component.
          onChange={this.updateValue} // The onChange event to call when the value changes.
        />
      </IntlProvider>,
      element,
      () => (this.reactInstance = instance),
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
